export default "__VITE_ASSET__bqUCVJAM__"